const translations = {
    en: {
        learnSomethingNew: "Learn something new",
        mainNavigation: "Main navigation",
        quizNavigation: "Quizzes",
        todayScoresPageLabel: "Today's top scores",
        todayScoresLoading: "Loading today's scores...",
        todayScoresLoadError: "Could not load today's scores. Please try again.",
        footerNavigation: "Footer navigation",
        aboutLink: "About",
        supportLink: "Support me",
        aboutTitle: "About Qouiz",
        aboutDescription: "Qouiz is a place to create, share, and take quizzes. Explore subjects, challenge yourself, and learn at your own pace.",
        supportTitle: "Support Qouiz",
        supportDescription: "You can support Qouiz by sharing it with students and teachers and by helping others discover useful quizzes. Thank you for being part of the community.",
        footerCopyright: "© {year} Qouiz",
        chooseQuiz: "Choose a quiz",
        catalogDescription: "Pick a topic and see how much you know.",
        searchLabel: "Search quizzes",
        searchPlaceholder: "Search by quiz or topic...",
        schoolClassroom: "School classroom",
        subjectLabel: "Subject",
        selectSubject: "Select a subject",
        allSchoolTracks: "All school tracks",
        generalClassroom: "General",
        selectClassroom: "Select a classroom",
        selectClassroomFirst: "Select a classroom first",
        allCategories: "All categories",
        sixthVocational: "Sixth vocational (سادس مهني)",
        sixthScientific: "Sixth scientific (سادس علمي)",
        sixthLiterary: "Sixth literary (سادس أدبي)",
        loadingQuizzes: "Loading quizzes...",
        loadQuizzesError: "Quizzes could not be loaded. Check the API connection and try again.",
        retry: "Retry",
        questions: "questions",
        newQuiz: "New",
        startQuiz: "Start quiz",
        quizAuthorLabel: "Quiz author",
        quizAuthorRole: "Quiz author",
        quizAuthorCategoryError: "Could not load quiz categories. Please try again.",
        createdBy: "Created by",
        authorUnknown: "Author unavailable",
        authorProfileLoading: "Loading author page...",
        authorProfileError: "Could not load this author page.",
        authorQuizzes: "Quizzes by this author",
        noAuthorQuizzes: "This author has no published quizzes yet.",
        quizDifficulty: "Difficulty",
        easyDifficulty: "Easy",
        hardDifficulty: "Hard",
        rateQuiz: "Rate quiz",
        averageRating: "Average rating",
        ratings: "ratings",
        ratingError: "Could not save your rating. Please try again.",
        reportWrongAnswer: "Report incorrect answer",
        questionReportSending: "Sending report...",
        questionReportSent: "Thanks. This question was reported for review.",
        questionReportError: "Could not send the report. Please try again.",
        quizAuthorLoadError: "Could not load your quizzes. Please try again.",
        quizAuthorDescription: "Edit your quizzes and review how learners perform.",
        myAuthoredQuizzes: "My quizzes",
        noAuthoredQuizzes: "You have not created any quizzes yet.",
        quizAnalytics: "Quiz analytics",
        authorQuestionReports: "Reports on my quizzes",
        noAuthorQuestionReports: "There are no reports for your quizzes.",
        viewQuizAnalysis: "View quiz analysis",
        hideQuizAnalysis: "Hide quiz analysis",
        questionPerformance: "Question performance",
        noQuestionAnalytics: "Question analysis will appear after learners complete this quiz.",
        correctAnswersRate: "correct",
        correctAnswers: "correct",
        incorrectAnswers: "incorrect",
        responses: "responses",
        authoredQuizCount: "Quizzes created",
        quizStarts: "Starts",
        quizCompletions: "Completions",
        quizParticipants: "people completed",
        completionRate: "Completion rate",
        startingQuiz: "Starting quiz...",
        startQuizError: "Could not start this quiz. Please try again.",
        noQuizzes: "No quizzes found. Try another search.",
        paginationNavLabel: "Quiz list pages",
        paginationSummary: "Showing {start}-{end} of {total}",
        paginationPage: "Page {page} of {pages}",
        previousPage: "Previous",
        nextPage: "Next",
        quiz: "Quiz",
        score: "Score",
        question: "Question",
        next: "Next",
        seeResults: "See results",
        complete: "complete!",
        shareOnFacebook: "Share on Facebook",
        youScored: "You scored",
        outOf: "out of",
        tryAgain: "Try again",
        chooseAnotherQuiz: "Choose another quiz",
        backToQuizzes: "Back to quizzes",
        darkMode: "🌙 Dark mode",
        lightMode: "☀️ Light mode",
        switchToDark: "Switch to dark mode",
        switchToLight: "Switch to light mode",
        switchToArabic: "العربية",
        switchToEnglish: "English",
        checkingSession: "Checking your session...",
        authWelcome: "Your quiz account",
        loginTitle: "Welcome back",
        loginDescription: "Log in to continue to your quizzes.",
        signUpTitle: "Create your account",
        signUpDescription: "Sign up to start exploring quizzes.",
        nameLabel: "Name",
        phoneLabel: "Iraqi mobile number",
        phonePlaceholder: "+964 7XX XXX XXXX",
        phoneHint: "Enter an Iraqi mobile number, such as 0770 123 4567 or +964 770 123 4567.",
        passwordLabel: "Password",
        passwordHint: "Use at least 8 characters.",
        loginButton: "Log in",
        signUpButton: "Sign up",
        authSubmitting: "Please wait...",
        needAccount: "New here?",
        haveAccount: "Already have an account?",
        logoutButton: "Log out",
        logoutError: "Could not log out. Please try again.",
        authConnectionError: "Could not connect to the authentication service.",
        authGenericError: "Authentication failed. Please try again.",
        loginResetRequestNotice: "After three incorrect attempts, a password reset request was sent to the admin if this phone belongs to an account.",
        requestPasswordReset: "Request password reset",
        passwordResetRequestSubmitted: "If an account uses this phone number, a password reset request has been sent to the admin.",
        authErrors: {
            invalid_phone: "Enter a valid Iraqi mobile number.",
            invalid_password: "Password must be at least 8 characters.",
            invalid_name: "Enter a name (up to 100 characters).",
            invalid_credentials: "Phone number or password is incorrect.",
            phone_exists: "An account with this phone number already exists. Log in with this number."
        },
        createQuizButton: "Create quiz",
        adminLabel: "Administrator",
        createQuizTitle: "Create a quiz",
        createQuizDescription: "Add quiz details, questions, and answer options.",
        pdfImportLabel: "Import questions from a PDF",
        pdfImportDescription: "Use numbered multiple-choice questions and a separate answer key. Scanned English and Arabic PDFs use OCR and need an internet connection. Review every imported question and answer before saving.",
        chooseFile: "Choose file",
        noFileChosen: "No file chosen",
        pdfImportReading: "Reading PDF...",
        pdfImportOcr: "Recognizing scanned pages... {progress}",
        pdfImportSuccess: "Imported {count} questions. Correct answers without matches: {unanswered}. Review before saving.",
        pdfImportInvalidFile: "Choose a PDF file.",
        pdfImportTooLarge: "The PDF must be 20 MB or smaller.",
        pdfImportTooManyPages: "The PDF must have 50 pages or fewer.",
        pdfImportNoQuestions: "No multiple-choice questions were found. Check the PDF format and answer key.",
        pdfImportQuestionLimit: "The PDF contains more than 30 questions. Import a smaller PDF.",
        pdfImportError: "Could not read this PDF. Try another file or check that it is not password-protected.",
        pdfImportReplaceConfirm: "Importing will replace the current question list. Continue?",
        pdfImportChooseAnswers: "Choose a correct answer for every question before saving.",
        textImportLabel: "Import a quiz from a text file",
        textImportDescription: "Import a .txt quiz exported from this editor. Importing replaces the current quiz details and questions.",
        textImportReading: "Reading quiz text...",
        textImportSuccess: "Imported {count} questions. Correct answers without matches: {unanswered}. Review before saving.",
        textImportTooLarge: "The text file must be 2 MB or smaller.",
        textImportInvalid: "This file does not contain a valid exported quiz.",
        textImportError: "Could not read this text file. Try exporting the quiz again.",
        exportQuizText: "Export quiz as text",
        quizTitleLabel: "Quiz title",
        quizCategoryLabel: "Category",
        quizDescriptionLabel: "Description",
        questionTextLabel: "Question text",
        answerOptionsLabel: "Answer options",
        optionLabel: "Option",
        correctAnswerLabel: "Correct answer",
        addQuestion: "Add question",
        removeQuestion: "Remove question",
        addOption: "Add option",
        removeOption: "Remove",
        saveQuiz: "Save quiz",
        saveAsDraft: "Save as draft",
        quizStatusLabel: "Status",
        publishedQuiz: "Published",
        draftQuiz: "Draft",
        duplicateOptionsInQuestion: "Question {question}: Answer options must be unique.",
        createQuizGenericError: "Could not create the quiz. Please try again.",
        createQuizConnectionError: "Could not connect to the quiz creation service.",
        createQuizErrors: {
            authentication_required: "Please log in to create quizzes.",
            quiz_author_required: "Only authorized quiz authors can create quizzes.",
            quiz_not_owned: "You can only edit quizzes you created.",
            invalid_difficulty: "Choose Easy or Hard for quiz difficulty.",
            invalid_school_track: "Select a valid school classroom.",
            admin_required: "Only administrators can edit quizzes.",
            invalid_title: "Enter a title of up to 150 characters.",
            invalid_category: "Enter a category of up to 100 characters.",
            invalid_description: "The description must be 500 characters or fewer.",
            invalid_status: "Choose a valid quiz status.",
            invalid_questions: "Add between 1 and 30 questions.",
            invalid_question: "Each question needs text (up to 1000 characters).",
            invalid_options: "Each question needs 2 to 6 non-empty answer options.",
            invalid_correct_answer: "Choose one correct answer for each question.",
            duplicate_options: "Answer options in a question must be unique.",
            category_not_found: "Choose a category from the list."
        },
        adminPanelButton: "Admin panel",
        adminPanelTitle: "Control panel",
        adminPanelDescription: "Manage quizzes, categories, and user access.",
        adminSections: "Admin sections",
        adminTabs: {
            overview: "Overview",
            quizzes: "Quizzes",
            categories: "Categories",
            users: "Users",
            reports: "Question reports",
            classrooms: "School classrooms",
            siteContent: "About and Support"
        },
        manageSchoolClassrooms: "Manage school classrooms and subjects",
        newSchoolClassroom: "New classroom name",
        addSchoolClassroom: "Add classroom",
        newSubject: "New subject name",
        addSubject: "Add subject",
        noSubjects: "No subjects added yet.",
        deleteSchoolClassroom: "Delete classroom",
        confirmDeleteSchoolClassroom: "Delete this classroom? Its quizzes will move to General",
        confirmDeleteSubject: "Delete this subject? Its quizzes will move to General",
        questionReportsTitle: "Reported questions",
        noQuestionReports: "There are no question reports.",
        reportedBy: "Reported by",
        reportOpen: "Needs review",
        reportResolved: "Resolved",
        editReportedQuestion: "Edit quiz questions",
        markReportResolved: "Mark resolved",
        adminLoading: "Loading control panel...",
        adminLoadError: "Could not load the control panel.",
        adminActionError: "The action could not be completed.",
        adminActionSuccess: "Changes saved successfully.",
        adminQuizCount: "Quizzes",
        adminUserCount: "Users",
        adminCategoryCount: "Categories",
        adminQuizzesTitle: "Manage quizzes",
        adminCategoriesTitle: "Manage categories",
        adminUsersTitle: "Manage users",
        userOnline: "Online",
        userOffline: "Offline",
        lastLogin: "Last login",
        lastLogout: "Last logout",
        never: "Never",
        adminPasswordResetHint: "Passwords are stored securely. You can reset a password, but cannot view the current one.",
        adminNewPasswordLabel: "New password",
        showPassword: "Show",
        hidePassword: "Hide",
        resetUserPassword: "Reset password",
        passwordResetRequested: "Password reset requested",
        failedLoginAttemptsLabel: "Incorrect attempts",
        noAdminQuizzes: "There are no quizzes yet.",
        editQuiz: "Edit",
        editQuizTitle: "Edit quiz",
        saveChanges: "Save changes",
        selectCategory: "Select a category",
        newCategoryLabel: "New category name",
        addCategory: "Add category",
        makeAdmin: "Make admin",
        removeAdmin: "Remove admin",
        makeQuizAuthor: "Allow quiz creation",
        removeQuizAuthor: "Remove quiz creation access",
        adminRole: "Administrator",
        userRole: "User",
        deleteButton: "Delete",
        confirmDeleteQuiz: "Delete quiz",
        confirmDeleteUser: "Delete user",
        adminErrors: {
            authentication_required: "Please log in again.",
            admin_required: "Administrator access is required.",
            invalid_category: "Enter a category name up to 100 characters.",
            category_exists: "That category already exists.",
            invalid_id: "The selected item is invalid.",
            invalid_role: "The selected role is invalid.",
            invalid_password: "The new password must be between 8 and 4096 characters.",
            user_not_found: "That user no longer exists.",
            quiz_not_found: "That quiz no longer exists.",
            report_not_found: "That question report no longer exists.",
            report_already_resolved: "That question report has already been resolved.",
            invalid_classroom: "Enter a classroom name up to 100 characters.",
            invalid_subject: "Enter a subject name and select a classroom.",
            classroom_not_found: "That classroom no longer exists.",
            subject_not_found: "That subject no longer exists.",
            subject_in_use: "This General subject is still used by quizzes.",
            item_exists: "A classroom or subject with that name already exists.",
            last_admin: "At least one administrator account must remain.",
            cannot_demote_self: "Another administrator must change your role.",
            cannot_delete_self: "You cannot delete your own account.",
            invalid_site_content: "Enter non-empty page text up to 5,000 characters."
        },
        userPanelButton: "My profile",
        userPanelLabel: "Your account",
        userPanelTitle: "My profile",
        userPanelWelcome: "Welcome,",
        userPanelLoading: "Loading your quiz history...",
        userPanelLoadError: "Could not load your quiz history.",
        profileSettings: "Profile settings",
        profileImageLabel: "Profile image",
        profileImageAlt: "Your profile",
        noProfileImage: "No profile image",
        profileImageHint: "JPEG, PNG, or WebP, up to 2 MB.",
        facebookProfileLabel: "Facebook profile URL",
        instagramProfileLabel: "Instagram profile URL",
        facebookLabel: "Facebook",
        instagramLabel: "Instagram",
        currentPasswordLabel: "Current password (required to change password)",
        newPasswordLabel: "New password",
        saveProfile: "Save profile",
        profileSaving: "Saving profile...",
        profileUpdated: "Your profile has been updated.",
        profileUpdateError: "Could not update your profile. Please try again.",
        profileErrors: {
            invalid_name: "Enter a name up to 100 characters.",
            invalid_password: "The new password must be at least 8 characters.",
            current_password_incorrect: "Your current password is incorrect.",
            invalid_social_link: "Enter a valid HTTPS URL for Facebook or Instagram.",
            invalid_image: "Choose a valid JPEG, PNG, or WebP image up to 2 MB.",
            image_upload_failed: "The image upload failed. Please choose it again.",
            authentication_required: "Please log in again to update your profile."
        },
        userStats: "Quiz statistics",
        completedQuizzes: "Completed quizzes",
        averageScore: "Overall accuracy",
        perfectScores: "Perfect scores",
        quizHistory: "Completed quiz history",
        noCompletedQuizzes: "You have not completed a quiz yet.",
        todayLeaderboardTitle: "Highest scores today",
        todayLeaderboardEmpty: "No quizzes have been completed today yet.",
        leaderboardPlayer: "Player",
        leaderboardQuiz: "Quiz",
        leaderboardScore: "Score",
        siteContentLoadError: "Could not load About and Support content.",
        siteContentLoading: "Loading page content...",
        siteContentTitle: "Edit About and Support pages",
        siteContentDescription: "Update the text shown on the public About and Support pages. Enter English and Arabic content.",
        aboutContentEnglishLabel: "About page — English",
        aboutContentArabicLabel: "About page — Arabic",
        supportContentEnglishLabel: "Support page — English",
        supportContentArabicLabel: "Support page — Arabic",
        saveSiteContent: "Save page content",
        savingSiteContent: "Saving page content...",
        startedQuizzes: "Quizzes you started",
        noStartedQuizzes: "You have not started a quiz yet.",
        startedAt: "Started",
        inProgress: "In progress",
        savingScore: "Saving your score...",
        scoreSaved: "Your score has been saved.",
        scoreSaveError: "Your score could not be saved.",
        retrySave: "Retry saving"
    },
    ar: {
        learnSomethingNew: "تعلّم شيئًا جديدًا",
        mainNavigation: "التنقل الرئيسي",
        quizNavigation: "الاختبارات",
        todayScoresPageLabel: "أعلى النتائج اليوم",
        todayScoresLoading: "جارٍ تحميل نتائج اليوم...",
        todayScoresLoadError: "تعذّر تحميل نتائج اليوم. حاول مرة أخرى.",
        footerNavigation: "روابط التذييل",
        aboutLink: "من نحن",
        supportLink: "ادعمنا",
        aboutTitle: "عن Qouiz",
        aboutDescription: "Qouiz مساحة لإنشاء الاختبارات ومشاركتها والإجابة عنها. استكشف المواد، واختبر معلوماتك، وتعلّم بالسرعة التي تناسبك.",
        supportTitle: "ادعم Qouiz",
        supportDescription: "يمكنك دعم Qouiz بمشاركته مع الطلاب والمعلمين ومساعدة الآخرين على اكتشاف اختبارات مفيدة. شكرًا لكونك جزءًا من المجتمع.",
        footerCopyright: "© {year} Qouiz",
        chooseQuiz: "اختر اختبارًا",
        catalogDescription: "اختر موضوعًا واختبر معلوماتك.",
        searchLabel: "ابحث عن اختبار",
        searchPlaceholder: "ابحث حسب اسم الاختبار أو الموضوع...",
        schoolClassroom: "الصف الدراسي",
        subjectLabel: "المادة",
        selectSubject: "اختر مادة",
        allSchoolTracks: "جميع الفروع الدراسية",
        generalClassroom: "عام",
        selectClassroom: "اختر الصف الدراسي",
        selectClassroomFirst: "اختر الصف الدراسي أولاً",
        allCategories: "جميع الفئات",
        sixthVocational: "سادس مهني",
        sixthScientific: "سادس علمي",
        sixthLiterary: "سادس أدبي",
        loadingQuizzes: "جارٍ تحميل الاختبارات...",
        loadQuizzesError: "تعذّر تحميل الاختبارات. تحقق من اتصال واجهة API ثم حاول مجددًا.",
        retry: "إعادة المحاولة",
        questions: "أسئلة",
        newQuiz: "جديد",
        startQuiz: "ابدأ الاختبار",
        quizAuthorLabel: "مؤلف الاختبار",
        quizAuthorRole: "مؤلف اختبار",
        quizAuthorCategoryError: "تعذّر تحميل فئات الاختبارات. حاول مرة أخرى.",
        createdBy: "أنشأه",
        authorUnknown: "المؤلف غير متاح",
        authorProfileLoading: "جارٍ تحميل صفحة المؤلف...",
        authorProfileError: "تعذّر تحميل صفحة هذا المؤلف.",
        authorQuizzes: "اختبارات هذا المؤلف",
        noAuthorQuizzes: "لا توجد اختبارات منشورة لهذا المؤلف بعد.",
        quizDifficulty: "مستوى الصعوبة",
        easyDifficulty: "سهل",
        hardDifficulty: "صعب",
        rateQuiz: "قيّم الاختبار",
        averageRating: "متوسط التقييم",
        ratings: "تقييمات",
        ratingError: "تعذّر حفظ تقييمك. حاول مرة أخرى.",
        reportWrongAnswer: "الإبلاغ عن إجابة خاطئة",
        questionReportSending: "جارٍ إرسال البلاغ...",
        questionReportSent: "شكرًا، تم الإبلاغ عن السؤال للمراجعة.",
        questionReportError: "تعذّر إرسال البلاغ. حاول مرة أخرى.",
        quizAuthorLoadError: "تعذّر تحميل اختباراتك. حاول مرة أخرى.",
        quizAuthorDescription: "عدّل اختباراتك واطّلع على أداء المشاركين.",
        myAuthoredQuizzes: "اختباراتي",
        noAuthoredQuizzes: "لم تنشئ أي اختبار بعد.",
        quizAnalytics: "تحليلات الاختبارات",
        authorQuestionReports: "البلاغات عن اختباراتي",
        noAuthorQuestionReports: "لا توجد بلاغات عن اختباراتك.",
        viewQuizAnalysis: "عرض تحليل الاختبار",
        hideQuizAnalysis: "إخفاء تحليل الاختبار",
        questionPerformance: "أداء الأسئلة",
        noQuestionAnalytics: "سيظهر تحليل الأسئلة بعد إكمال المتعلمين لهذا الاختبار.",
        correctAnswersRate: "إجابات صحيحة",
        correctAnswers: "صحيح",
        incorrectAnswers: "خطأ",
        responses: "إجابة",
        authoredQuizCount: "الاختبارات المنشأة",
        quizStarts: "مرات البدء",
        quizCompletions: "مرات الإكمال",
        quizParticipants: "أشخاص أكملوا الاختبار",
        completionRate: "معدل الإكمال",
        startingQuiz: "جارٍ بدء الاختبار...",
        startQuizError: "تعذّر بدء هذا الاختبار. حاول مرة أخرى.",
        noQuizzes: "لم نعثر على اختبارات. جرّب بحثًا آخر.",
        paginationNavLabel: "صفحات قائمة الاختبارات",
        paginationSummary: "عرض {start}-{end} من أصل {total}",
        paginationPage: "الصفحة {page} من {pages}",
        previousPage: "السابق",
        nextPage: "التالي",
        quiz: "اختبار",
        score: "النتيجة",
        question: "السؤال",
        next: "التالي",
        seeResults: "عرض النتيجة",
        complete: "اكتمل!",
        shareOnFacebook: "مشاركة على فيسبوك",
        youScored: "نتيجتك",
        outOf: "من",
        tryAgain: "أعد الاختبار",
        chooseAnotherQuiz: "اختر اختبارًا آخر",
        backToQuizzes: "العودة إلى الاختبارات",
        darkMode: "🌙 الوضع الداكن",
        lightMode: "☀️ الوضع الفاتح",
        switchToDark: "التبديل إلى الوضع الداكن",
        switchToLight: "التبديل إلى الوضع الفاتح",
        switchToArabic: "العربية",
        switchToEnglish: "English",
        checkingSession: "جارٍ التحقق من الجلسة...",
        authWelcome: "حساب الاختبارات",
        loginTitle: "مرحبًا بعودتك",
        loginDescription: "سجّل الدخول للمتابعة إلى اختباراتك.",
        signUpTitle: "أنشئ حسابك",
        signUpDescription: "أنشئ حسابًا لبدء استكشاف الاختبارات.",
        nameLabel: "الاسم",
        phoneLabel: "رقم الهاتف العراقي",
        phonePlaceholder: "+964 7XX XXX XXXX",
        phoneHint: "أدخل رقم هاتف عراقيًا، مثل 0770 123 4567 أو +964 770 123 4567.",
        passwordLabel: "كلمة المرور",
        passwordHint: "استخدم ٨ أحرف على الأقل.",
        loginButton: "تسجيل الدخول",
        signUpButton: "إنشاء حساب",
        authSubmitting: "يرجى الانتظار...",
        needAccount: "مستخدم جديد؟",
        haveAccount: "لديك حساب بالفعل؟",
        logoutButton: "تسجيل الخروج",
        logoutError: "تعذّر تسجيل الخروج. حاول مرة أخرى.",
        authConnectionError: "تعذّر الاتصال بخدمة تسجيل الدخول.",
        authGenericError: "فشل التحقق. حاول مرة أخرى.",
        loginResetRequestNotice: "بعد ثلاث محاولات غير صحيحة، تم إرسال طلب إعادة تعيين كلمة المرور إلى المسؤول إذا كان هذا الرقم مرتبطًا بحساب.",
        requestPasswordReset: "طلب إعادة تعيين كلمة المرور",
        passwordResetRequestSubmitted: "إذا كان هناك حساب يستخدم هذا الرقم، فقد تم إرسال طلب إعادة تعيين كلمة المرور إلى المسؤول.",
        authErrors: {
            invalid_phone: "أدخل رقم هاتف عراقيًا صالحًا.",
            invalid_password: "يجب ألا تقل كلمة المرور عن ٨ أحرف.",
            invalid_name: "أدخل اسمًا (بحد أقصى ١٠٠ حرف).",
            invalid_credentials: "رقم الهاتف أو كلمة المرور غير صحيحة.",
            phone_exists: "يوجد حساب بهذا الرقم بالفعل. سجّل الدخول باستخدام هذا الرقم."
        },
        createQuizButton: "إنشاء اختبار",
        adminLabel: "مسؤول",
        createQuizTitle: "إنشاء اختبار",
        createQuizDescription: "أضف تفاصيل الاختبار والأسئلة وخيارات الإجابة.",
        pdfImportLabel: "استيراد الأسئلة من ملف PDF",
        pdfImportDescription: "استخدم أسئلة اختيار من متعدد مرقمة ومفتاح إجابات منفصلًا. تستخدم الملفات المصورة بالإنجليزية والعربية تقنية OCR وتتطلب اتصالًا بالإنترنت. راجع كل سؤال وإجابة مستوردة قبل الحفظ.",
        chooseFile: "اختيار ملف",
        noFileChosen: "لم يتم اختيار ملف",
        pdfImportReading: "جارٍ قراءة ملف PDF...",
        pdfImportOcr: "جارٍ التعرّف على الصفحات المصورة... {progress}",
        pdfImportSuccess: "تم استيراد {count} سؤالًا. الإجابات الصحيحة التي لم تُطابق: {unanswered}. راجعها قبل الحفظ.",
        pdfImportInvalidFile: "اختر ملف PDF.",
        pdfImportTooLarge: "يجب ألا يتجاوز حجم ملف PDF ‏20 ميغابايت.",
        pdfImportTooManyPages: "يجب ألا يزيد ملف PDF عن 50 صفحة.",
        pdfImportNoQuestions: "لم يتم العثور على أسئلة اختيار من متعدد. تحقق من تنسيق الملف ومفتاح الإجابات.",
        pdfImportQuestionLimit: "يحتوي ملف PDF على أكثر من 30 سؤالًا. استورد ملفًا أصغر.",
        pdfImportError: "تعذرت قراءة ملف PDF. جرّب ملفًا آخر أو تحقق من أنه غير محمي بكلمة مرور.",
        pdfImportReplaceConfirm: "سيؤدي الاستيراد إلى استبدال قائمة الأسئلة الحالية. هل تريد المتابعة؟",
        pdfImportChooseAnswers: "اختر إجابة صحيحة لكل سؤال قبل الحفظ.",
        textImportLabel: "استيراد اختبار من ملف نصي",
        textImportDescription: "استورد ملف ‎.txt تم تصديره من هذا المحرر. سيؤدي الاستيراد إلى استبدال تفاصيل الاختبار وأسئلته الحالية.",
        textImportReading: "جارٍ قراءة نص الاختبار...",
        textImportSuccess: "تم استيراد {count} سؤالًا. الإجابات الصحيحة التي لم تُطابق: {unanswered}. راجعها قبل الحفظ.",
        textImportTooLarge: "يجب ألا يتجاوز حجم الملف النصي ٢ ميغابايت.",
        textImportInvalid: "لا يحتوي هذا الملف على اختبار مُصدّر صالح.",
        textImportError: "تعذرت قراءة هذا الملف النصي. حاول تصدير الاختبار مرة أخرى.",
        exportQuizText: "تصدير الاختبار كنص",
        quizTitleLabel: "عنوان الاختبار",
        quizCategoryLabel: "الفئة",
        quizDescriptionLabel: "الوصف",
        questionTextLabel: "نص السؤال",
        answerOptionsLabel: "خيارات الإجابة",
        optionLabel: "الخيار",
        correctAnswerLabel: "الإجابة الصحيحة",
        addQuestion: "إضافة سؤال",
        removeQuestion: "حذف السؤال",
        addOption: "إضافة خيار",
        removeOption: "حذف",
        saveQuiz: "حفظ الاختبار",
        saveAsDraft: "حفظ كمسودة",
        quizStatusLabel: "الحالة",
        publishedQuiz: "منشور",
        draftQuiz: "مسودة",
        duplicateOptionsInQuestion: "السؤال {question}: يجب أن تكون خيارات الإجابة مختلفة.",
        createQuizGenericError: "تعذّر إنشاء الاختبار. حاول مرة أخرى.",
        createQuizConnectionError: "تعذّر الاتصال بخدمة إنشاء الاختبارات.",
        createQuizErrors: {
            authentication_required: "سجّل الدخول لإنشاء الاختبارات.",
            quiz_author_required: "يمكن لمؤلفي الاختبارات المصرح لهم فقط إنشاء الاختبارات.",
            quiz_not_owned: "يمكنك تعديل الاختبارات التي أنشأتها فقط.",
            invalid_difficulty: "اختر سهل أو صعب لمستوى الاختبار.",
            invalid_school_track: "اختر صفًا دراسيًا صالحًا.",
            admin_required: "يمكن للمسؤولين فقط تعديل الاختبارات.",
            invalid_title: "أدخل عنوانًا لا يتجاوز ١٥٠ حرفًا.",
            invalid_category: "أدخل فئة لا تتجاوز ١٠٠ حرف.",
            invalid_description: "يجب ألا يتجاوز الوصف ٥٠٠ حرف.",
            invalid_status: "اختر حالة اختبار صالحة.",
            invalid_questions: "أضف من سؤال إلى ٣٠ سؤالًا.",
            invalid_question: "أدخل نصًا لكل سؤال (حتى ١٠٠٠ حرف).",
            invalid_options: "يحتاج كل سؤال إلى ٢ إلى ٦ خيارات غير فارغة.",
            invalid_correct_answer: "اختر إجابة صحيحة لكل سؤال.",
            duplicate_options: "يجب أن تكون خيارات السؤال مختلفة.",
            category_not_found: "اختر فئة من القائمة."
        },
        adminPanelButton: "لوحة التحكم",
        adminPanelTitle: "لوحة التحكم",
        adminPanelDescription: "إدارة الاختبارات والفئات وصلاحيات المستخدمين.",
        adminSections: "أقسام لوحة التحكم",
        adminTabs: {
            overview: "نظرة عامة",
            quizzes: "الاختبارات",
            categories: "الفئات",
            users: "المستخدمون",
            reports: "بلاغات الأسئلة",
            classrooms: "الصفوف الدراسية",
            siteContent: "حول الموقع والدعم"
        },
        manageSchoolClassrooms: "إدارة الصفوف الدراسية والمواد",
        newSchoolClassroom: "اسم الصف الدراسي الجديد",
        addSchoolClassroom: "إضافة صف دراسي",
        newSubject: "اسم المادة الجديدة",
        addSubject: "إضافة مادة",
        noSubjects: "لم تتم إضافة مواد بعد.",
        deleteSchoolClassroom: "حذف الصف الدراسي",
        confirmDeleteSchoolClassroom: "حذف هذا الصف الدراسي؟ ستُنقل اختباراته إلى عام",
        confirmDeleteSubject: "حذف هذه المادة؟ ستُنقل اختباراتها إلى عام",
        questionReportsTitle: "الأسئلة التي تم الإبلاغ عنها",
        noQuestionReports: "لا توجد بلاغات عن الأسئلة.",
        reportedBy: "أبلغ عنه",
        reportOpen: "بانتظار المراجعة",
        reportResolved: "تمت المراجعة",
        editReportedQuestion: "تعديل أسئلة الاختبار",
        markReportResolved: "وضع علامة تمت المراجعة",
        adminLoading: "جارٍ تحميل لوحة التحكم...",
        adminLoadError: "تعذّر تحميل لوحة التحكم.",
        adminActionError: "تعذّر تنفيذ الإجراء.",
        adminActionSuccess: "تم حفظ التغييرات بنجاح.",
        adminQuizCount: "الاختبارات",
        adminUserCount: "المستخدمون",
        adminCategoryCount: "الفئات",
        adminQuizzesTitle: "إدارة الاختبارات",
        adminCategoriesTitle: "إدارة الفئات",
        adminUsersTitle: "إدارة المستخدمين",
        userOnline: "متصل الآن",
        userOffline: "غير متصل",
        lastLogin: "آخر تسجيل دخول",
        lastLogout: "آخر تسجيل خروج",
        never: "أبدًا",
        adminPasswordResetHint: "تُحفظ كلمات المرور بأمان. يمكنك إعادة تعيين كلمة المرور، لكن لا يمكنك رؤية كلمة المرور الحالية.",
        adminNewPasswordLabel: "كلمة المرور الجديدة",
        showPassword: "إظهار",
        hidePassword: "إخفاء",
        resetUserPassword: "إعادة تعيين كلمة المرور",
        passwordResetRequested: "طلب إعادة تعيين كلمة المرور",
        failedLoginAttemptsLabel: "المحاولات غير الصحيحة",
        noAdminQuizzes: "لا توجد اختبارات بعد.",
        editQuiz: "تعديل",
        editQuizTitle: "تعديل الاختبار",
        saveChanges: "حفظ التغييرات",
        selectCategory: "اختر فئة",
        newCategoryLabel: "اسم الفئة الجديدة",
        addCategory: "إضافة فئة",
        makeAdmin: "تعيين مسؤول",
        removeAdmin: "إزالة صلاحية المسؤول",
        makeQuizAuthor: "السماح بإنشاء الاختبارات",
        removeQuizAuthor: "إزالة صلاحية إنشاء الاختبارات",
        adminRole: "مسؤول",
        userRole: "مستخدم",
        deleteButton: "حذف",
        confirmDeleteQuiz: "حذف الاختبار",
        confirmDeleteUser: "حذف المستخدم",
        adminErrors: {
            authentication_required: "يرجى تسجيل الدخول مرة أخرى.",
            admin_required: "هذه الصفحة مخصصة للمسؤولين.",
            invalid_category: "أدخل اسم فئة لا يتجاوز ١٠٠ حرف.",
            category_exists: "هذه الفئة موجودة بالفعل.",
            invalid_id: "العنصر المحدد غير صالح.",
            invalid_role: "الصلاحية المحددة غير صالحة.",
            invalid_password: "يجب أن تتراوح كلمة المرور الجديدة بين ٨ و٤٠٩٦ حرفًا.",
            user_not_found: "هذا المستخدم لم يعد موجودًا.",
            quiz_not_found: "هذا الاختبار لم يعد موجودًا.",
            report_not_found: "بلاغ السؤال لم يعد موجودًا.",
            report_already_resolved: "تمت مراجعة هذا البلاغ بالفعل.",
            invalid_classroom: "أدخل اسم صف دراسي لا يتجاوز ١٠٠ حرف.",
            invalid_subject: "أدخل اسم المادة واختر الصف الدراسي.",
            classroom_not_found: "هذا الصف الدراسي لم يعد موجودًا.",
            subject_not_found: "هذه المادة لم تعد موجودة.",
            subject_in_use: "لا تزال اختبارات تستخدم مادة عام هذه.",
            item_exists: "يوجد صف دراسي أو مادة بهذا الاسم بالفعل.",
            last_admin: "يجب الاحتفاظ بحساب مسؤول واحد على الأقل.",
            cannot_demote_self: "يجب أن يغيّر مسؤول آخر صلاحيتك.",
            cannot_delete_self: "لا يمكنك حذف حسابك.",
            invalid_site_content: "أدخل نصًا غير فارغ للصفحات، بحد أقصى ٥٠٠٠ حرف."
        },
        userPanelButton: "ملفي الشخصي",
        userPanelLabel: "حسابك",
        userPanelTitle: "ملفي الشخصي",
        userPanelWelcome: "مرحبًا،",
        userPanelLoading: "جارٍ تحميل سجل الاختبارات...",
        userPanelLoadError: "تعذّر تحميل سجل الاختبارات.",
        profileSettings: "إعدادات الملف الشخصي",
        profileImageLabel: "الصورة الشخصية",
        profileImageAlt: "صورتك الشخصية",
        noProfileImage: "لا توجد صورة شخصية",
        profileImageHint: "JPEG أو PNG أو WebP، بحد أقصى ٢ ميغابايت.",
        facebookProfileLabel: "رابط حساب فيسبوك",
        instagramProfileLabel: "رابط حساب إنستغرام",
        facebookLabel: "فيسبوك",
        instagramLabel: "إنستغرام",
        currentPasswordLabel: "كلمة المرور الحالية (مطلوبة لتغيير كلمة المرور)",
        newPasswordLabel: "كلمة المرور الجديدة",
        saveProfile: "حفظ الملف الشخصي",
        profileSaving: "جارٍ حفظ الملف الشخصي...",
        profileUpdated: "تم تحديث ملفك الشخصي.",
        profileUpdateError: "تعذّر تحديث ملفك الشخصي. حاول مرة أخرى.",
        profileErrors: {
            invalid_name: "أدخل اسمًا لا يتجاوز ١٠٠ حرف.",
            invalid_password: "يجب ألا تقل كلمة المرور الجديدة عن ٨ أحرف.",
            current_password_incorrect: "كلمة المرور الحالية غير صحيحة.",
            invalid_social_link: "أدخل رابط HTTPS صالحًا لفيسبوك أو إنستغرام.",
            invalid_image: "اختر صورة JPEG أو PNG أو WebP صالحة بحد أقصى ٢ ميغابايت.",
            image_upload_failed: "فشل تحميل الصورة. اخترها مرة أخرى.",
            authentication_required: "سجّل الدخول مرة أخرى لتحديث ملفك الشخصي."
        },
        userStats: "إحصائيات الاختبارات",
        completedQuizzes: "الاختبارات المكتملة",
        averageScore: "معدل الإجابات الصحيحة",
        perfectScores: "النتائج الكاملة",
        quizHistory: "سجل الاختبارات المكتملة",
        noCompletedQuizzes: "لم تكمل أي اختبار بعد.",
        todayLeaderboardTitle: "أعلى النتائج اليوم",
        todayLeaderboardEmpty: "لم يُكمل أحد أي اختبار اليوم حتى الآن.",
        leaderboardPlayer: "اللاعب",
        leaderboardQuiz: "الاختبار",
        leaderboardScore: "النتيجة",
        siteContentLoadError: "تعذّر تحميل محتوى صفحتي حول الموقع والدعم.",
        siteContentLoading: "جارٍ تحميل محتوى الصفحة...",
        siteContentTitle: "تعديل صفحتي حول الموقع والدعم",
        siteContentDescription: "حدّث النص الظاهر في صفحتي حول الموقع والدعم. أدخل المحتوى باللغتين العربية والإنجليزية.",
        aboutContentEnglishLabel: "صفحة حول الموقع — الإنجليزية",
        aboutContentArabicLabel: "صفحة حول الموقع — العربية",
        supportContentEnglishLabel: "صفحة الدعم — الإنجليزية",
        supportContentArabicLabel: "صفحة الدعم — العربية",
        saveSiteContent: "حفظ محتوى الصفحة",
        savingSiteContent: "جارٍ حفظ محتوى الصفحة...",
        startedQuizzes: "الاختبارات التي بدأتها",
        noStartedQuizzes: "لم تبدأ أي اختبار بعد.",
        startedAt: "بدأ في",
        inProgress: "قيد التقدم",
        savingScore: "جارٍ حفظ نتيجتك...",
        scoreSaved: "تم حفظ نتيجتك.",
        scoreSaveError: "تعذّر حفظ نتيجتك.",
        retrySave: "إعادة محاولة الحفظ"
    }
};

export default translations;
